import { StyledLoginContainer } from '../style';
import { ELoginMode, EOTPTextModel, EPlatformType } from '../../Helper/enums';
import ProvidersMode from '../LoginMode/providers';
import UsernamePasswordMode from '../LoginMode/username';
import LoginIdMode from '../LoginMode/loginId';
import OtpMode from '../LoginMode/OTP';
import { LoginPage } from '../types';
import { useEffect, useState } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';

export const LoginButtonBlocks = ({
    mode,
    openInfoModal,
    loginResponse,
    stopLoader,
    startLoader,
    loginButtonClickWrapper,
    playerAuthData,
    otpDeeplink,
    otpButton,
    setMode,
    trackLoginEvent,
    otpProofKey,
    otpTokenKey,
    getOtp,
    maxWidth = '400px',
    translations
}: LoginPage & { maxWidth?: string }) => {
    const [deepLink, setDeepLink] = useState<string>('');

    useEffect(() => {
        if (!playerAuthData?.otpLinks) return;
        const findDeepLink = (platform: EPlatformType) => {
            playerAuthData?.otpLinks.forEach((link) => {
                if (link.platform === platform) {
                    setDeepLink(link.deepLink);
                }
            });
        };
        if (isIOS) {
            findDeepLink(EPlatformType.IOS);
        } else if (isAndroid) {
            findDeepLink(EPlatformType.ANDROID);
        } else {
            findDeepLink(EPlatformType.WEB);
        }
    }, []);

    const openHowToFindId = () => {
        openInfoModal(playerAuthData.userTokenUrl);
    };

    const showUserTokenLink =
        (mode === ELoginMode.PROVIDERS || mode === ELoginMode.TOKEN_ID) &&
        playerAuthData.userTokenUrl &&
        playerAuthData.userTokenText;

    return (
        <StyledLoginContainer maxWidth={maxWidth}>
            {mode === ELoginMode.PROVIDERS && (
                <ProvidersMode
                    openInfoModal={openInfoModal}
                    loginResponse={loginResponse}
                    stopLoader={stopLoader}
                    startLoader={startLoader}
                    loginButtonClickWrapper={loginButtonClickWrapper}
                    playerAuthData={playerAuthData}
                    deepLink={deepLink}
                    otpDeeplink={otpDeeplink}
                    otpButton={otpButton}
                    setMode={setMode}
                    trackLoginEvent={trackLoginEvent}
                    translations={translations!}
                />
            )}
            {mode === ELoginMode.USERNAME && (
                <UsernamePasswordMode
                    loginButtonClickWrapper={loginButtonClickWrapper}
                    submit={loginResponse}
                    trackLoginEvent={trackLoginEvent}
                />
            )}
            {mode === ELoginMode.TOKEN_ID && (
                <LoginIdMode
                    loginButtonClickWrapper={loginButtonClickWrapper}
                    submit={loginResponse}
                    trackLoginEvent={trackLoginEvent}
                    translations={translations!}
                />
            )}
            {(otpProofKey || mode === ELoginMode.OTP) && (
                <OtpMode
                    otpButton={otpButton!}
                    submit={loginResponse}
                    model={playerAuthData.otpModel}
                    numOfDigits={
                        playerAuthData.otpTextModel === EOTPTextModel.SIX_DIGITS
                            ? 6
                            : 4
                    }
                    getOtp={getOtp}
                    otpProofKey={otpProofKey}
                    otpTokenKey={otpTokenKey}
                    loginButtonClickWrapper={loginButtonClickWrapper}
                    trackLoginEvent={trackLoginEvent}
                />
            )}
            {showUserTokenLink && (
                <p className="userTokenLink" onClick={openHowToFindId}>
                    {playerAuthData.userTokenText}
                </p>
            )}
        </StyledLoginContainer>
    );
};
